import history from './history';

// In most cases Retail navigation happens at the domain root level '/'.
// It also happens that retail is reading controllers from inside folders but
// the paths always ends by .php extension (/oauth/remove_openid.php).
// If these conditions are not met, router should be initializing a React page.
function isReactPagePath() {
  return window.location.pathname !== '/' && !~window.location.pathname.indexOf('.php');
}

window.isReactPage = isReactPagePath();

// Page router class is how React page is mounted. It hides all of Retail
// gui_def containers and sends a mounting event `/pages/index.js` to mount
// the Reaqct app. Use `PageRouter.goTo('/inventory/pagex')`.
export default class PageRouter implements RetailPageRouter {
  goTo(url: string, historyHandler: string = 'push') {
    this.mount(url, historyHandler);
    window.history.clearLeaveStateStack();
  }

  /**
   * Don't call this method directly, use `goTo`.
   * It sends a mount event to the Page component
   * @param {String} url reactRouter url to mount
   * @param {String} historyHandler 'push' or 'replace'
   * if mounted manually, will be 'push', if through browser popstate 'replace'
   */
  mount(url: string, historyHandler: string) {
    // Handle PUSH and REPLACE history to be in sync for react-router
    if (historyHandler) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      history[historyHandler](url);
    }

    // If current location is a react page, and next or previous is also a react page
    // This prevents re-mounting and only writes in the history
    if (window.isReactPage) return;

    window.isReactPage = true;

    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
    window.merchantos.page.hide();

    // Timeout added to mount after history change.
    setTimeout(() => {
      window.merchantos.asyncSubscribe.notifySubscribers('react.mount.page', {
        props: {
          url,
        },
      });
    });
  }

  unmount() {
    if (!window.isReactPage) return;
    window.isReactPage = false;

    window.merchantos.asyncSubscribe.notifySubscribers('react.unmount.page');
  }
}

window.PageRouter = new PageRouter();

// window.onpopstate is preserved so the existing behaviours still works.
// The declaration here instead of inside router.js is to keep all of the
// `mount / unmount` code at the same place.
const routerOnpopstate = window.onpopstate;

window.onpopstate = (event: TSFixMe) => {
  // Handle the history `back / previous` to `mount / unmount` the react page
  if (isReactPagePath()) {
    window.PageRouter.mount(
      event.target.location.pathname + event.target.location.search,
      'replace'
    );
    return;
  }

  window.PageRouter.unmount();
  routerOnpopstate(event);
};
